import GATSBY_COMPILED_MDX from "/opt/actions-runner/_work/ustwo-website/ustwo-website/src/content/case-studies/jaguar-land-rover.mdx";
import {graphql} from "gatsby";
import {GatsbyImage} from 'gatsby-plugin-image';
import React from "react";
import {MDXProvider} from '@mdx-js/react';
import Grid, {Col} from "../components/grid/Grid";
import Meta from "../components/meta/Meta";
import Section from "../components/section/Section";
import Video from "../components/video/Video";
import ShowcaseHeader from "../components/showcaseHeader/showcaseHeader";
import "../components/articleContent/ArticleContent.module.css";
const Image = ({image, alt}) => React.createElement(GatsbyImage, {
  image: image,
  alt: alt
});
const CaseStudySimple = ({data, children}) => {
  const shortcodes = {
    Image,
    Video
  };
  return React.createElement("article", null, React.createElement(ShowcaseHeader, {
    title: data.content.frontmatter.title,
    tagline: data.content.frontmatter.tagline,
    backgroundImage: data.content?.hero?.childImageSharp,
    mobileBackgroundImage: data.content?.thumbnail?.childImageSharp,
    lightOnDarkDesktop: data.content.frontmatter.lightOnDarkDesktop,
    backgroundGradient: data.content.frontmatter.darkGradient,
    largeTagline: true
  }), React.createElement(Section, {
    padding: "both",
    className: "simpleCaseStudy",
    noInner: true
  }, React.createElement(Grid, null, React.createElement(Col, {
    span: 8,
    start: 3
  }, React.createElement(MDXProvider, {
    components: shortcodes
  }, children)))));
};
CaseStudySimple
export default function GatsbyMDXWrapper(props) {
  return React.createElement(CaseStudySimple, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({data}) => {
  const {title, tagline, noIndex} = data.content.frontmatter;
  return React.createElement(Meta, {
    title: `${title} x ustwo`,
    description: tagline,
    imgsrc: data.content.thumbnail && data.content.thumbnail.publicURL,
    noIndex: noIndex
  });
};
export const query = graphql`
  query($name: String) {
    content: mdx(frontmatter: { name: { eq: $name } }) {
      frontmatter {
        name
        title
        tagline
        lightOnDarkDesktop
        darkGradient
        noIndex
      }
      thumbnail {
        publicURL
        childImageSharp {
          gatsbyImageData
        }
      }
      hero {
        childImageSharp {
          gatsbyImageData
        }
      }
      images {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
`;
